import React, { useState } from 'react';
import Steps from '../../Components/Steps';
import { useAppSelector } from '../../hooks';
import BecomeFPSteps from './BecomeFPSteps';

const steps = [
  { id: 'Step 1', name: 'Read Documentation', status: 'current' },
  { id: 'Step 2', name: 'Opt In', status: 'upcoming' },
  { id: 'Step 3', name: 'Pay Deposit', status: 'upcoming' },
  { id: 'Step 3', name: 'Complete', status: 'upcoming' },
]

export default function BecomeFeedProvider() {
  const [page, setPage ] = useState(steps);
  const [pageCount, setPageCount ] = useState(0);
  const subscription = useAppSelector(state => state.subscription)

  const handleNext = () => {
    if (pageCount < 3){
      steps[pageCount].status = 'complete'
      steps[pageCount + 1].status = 'current'
      setPageCount(pageCount + 1);
      setPage(steps);
    }
  }
  
  const handleBack = () => {
    if (pageCount > 0 ){
      steps[pageCount].status = 'current'
      steps[pageCount + 1].status = 'upcoming'
      setPageCount(pageCount - 1);
      setPage(steps);
    }
  }

  const canGoNext = () => {
    if(pageCount == 0) return true;
    if(pageCount == 1 && subscription.optInStepPassed ) return true;
    if(pageCount == 2 && subscription.depositStepPassed) return true;
    return false;
  }

  return (
    <div className="mx-10 bg-white overflow-hidden shadow rounded-lg divide-y divide-gray-200">
      <div className="px-4 py-5 sm:px-6">
        <h2 className="text-2xl mb-10 font-bold pb leading-7 text-gray-900 sm:text-3xl sm:truncate">
          Become A Feed Provider
        </h2>
        <Steps stepItems={steps} />
      </div>
      <div className="px-4  py-5 sm:p-6">
        <BecomeFPSteps pageCount={pageCount} />
      </div>
      <div className="flex  px-4 py-4 sm:px-6">
        {(pageCount !==0 && pageCount !== 3) && <button
          onClick={() => handleBack()}
          type="button"
          className="  px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Back
        </button>}
        {canGoNext() && <button
          onClick={() => handleNext()}
          type="button"
          className="ml-auto  px-4 py-2 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
        >
          Next
        </button>}
      </div>
    </div>
  );
}
